import React, { useState } from "react";
import "./Mid-Section-Pc.scss";

//import components
import InformationCardPc from "../../OverView/Pc-and-Large-Screens/Information-Card-Pc";
import TransactionsTable from "../../OverView/Pc-and-Large-Screens/Payments-Table";
import InvoicePendingTable from "../../Payments/Pc-and-Large-Screens/InvoicesPendingTable";

const MidSectionInvoicesPc = () => {
  const [tableToView, setTableToView] = useState("invoices");

  const cardData1 = {
    Title: "Invoices Paid",
    water: "5000",
    rent: "5000",
    arrears: "2000",
    garbage: "1000",
  };
  return (
    <div className="mid-section-invoices-pc-invoices">
      <div className="title">
        View Invoices
        <div className="description">
          View Pending Invoices and non approved payments
        </div>
      </div>
      <div className="cards-container">
     
        <InformationCardPc
          Title={"Invoices Pending"}
          Ammount={"20,000"}
          setTableToView={setTableToView}
          valueToSet={"invoices"}
        />
         <InformationCardPc
          Title={cardData1.Title}
          Ammount={"10,000"}
          setTableToView={setTableToView}
          valueToSet={"transactions"}
          // cardData={[cardData1.water, cardData1.rent, cardData1.arrears, cardData1.garbage]}
        />
          <InformationCardPc
          Title={"Pending approval"}
          Ammount={"5,000"}
          setTableToView={setTableToView}
          valueToSet={"transactions-pending"}
        />
        <InformationCardPc
          Title={"Other charges"}
          Ammount={"5,000"}
          setTableToView={setTableToView}
        />
      </div>
      <div className="transactions-and-progress">
        <div className="transactions-container">
          <div className="title">
            {tableToView === "transactions" && (
              <div className="description">Latest Transactions</div>
            )}
            {tableToView === "invoices" && (
              <div className="description">Pending Invoices</div>
            )}
          </div>

          <div className="transaction-history-table">
            {tableToView === "invoices" && <InvoicePendingTable />}
            {tableToView === "transactions" && <TransactionsTable />}
            {tableToView === "transactions-pending" && (
              <TransactionsTable pendingApproval={true} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MidSectionInvoicesPc;
